import {GET_EVENT_DETAILS, GET_EVENT_DETAILS_ERROR} from '../types'
import axios from 'axios'
import { ROUTE, PATH } from "../constants";
import { is_login } from './is_login';

export const getEventDetailsAction = (token,event) => async dispatch => {
    try{
        // console.log(event);
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        const API = `${process.env.REACT_APP_SERVER_HOST}${PATH}${is_login()?ROUTE.EVENT_BY_ID:ROUTE.EVENT_BY_ID_BEFORE_LOGIN}/${event.id}`;
        const res = await axios.get(API,config);
        dispatch( {
            type: GET_EVENT_DETAILS,
            payload: res.data
        })
    }
    catch(error){
        console.log(error);
        dispatch( {
            type: GET_EVENT_DETAILS_ERROR,
            payload: error,
        })
    }

}

